<template>
  <GridContainer
    padding
    class="google__info-tiles"
  >
    <GridRow>
      <GridColumn>
        <Heading
          v-if="tilesData.title"
          :text="tilesData.title"
          class="google__info-tiles__grid__item"
          font-weight="ultra"
          size="lg"
          tag="h2"
          text-uppercase
          align="center"
          spaces-top
        />
        <Heading
          v-if="tilesData.subtitle"
          :text="tilesData.subtitle"
          class="google__info-tiles__grid__item"
          font-weight="regular"
          size="sm"
          tag="h3"
          align="center"
          spaces-top
          spaces-bottom
        />
      </GridColumn>
    </GridRow>
    <GridRow class="google__info-tiles__row">
      <GridColumn
        v-for="item in tilesData.items"
        :key="item.title"
        :style="item.style"
        class="google__info-tiles__col--p"
      >
        <CdnImage
          v-if="item.bgImage"
          :alt="item.title"
          :src="item.bgImage"
          class="google__info-tiles__col-bg"
          lazy
        />
        <CdnImage
          :ref="`grid-${item.ref}`"
          :alt="item.title"
          :src="item.icon"
          :style="item.imageStyle"
          class="google__info-tiles__col__icon"
          render-without-figure
          lazy
        />
        <div>
          <Heading
            :text="item.title"
            size="sm"
            align="center"
            :tag="item.tag"
            spaces-bottom
            spaces-top
          />
          <Paragraph
            align="center"
            class="google__info-tiles__col__par"
          >
            {{ item.text }}
          </Paragraph>
        </div>
      </GridColumn>
    </GridRow>
    <GridRow v-show="showLink">
      <LinkButton
        tag="button"
        text
        class="google__info-tiles__link"
        @click="$emit('go-to-section', 'specsTable')"
      >
        Weitere Vorteile im Überblick
      </LinkButton>
    </GridRow>
  </GridContainer>
</template>

<script>
import {
  GridContainer,
  GridRow,
  GridColumn,
  Paragraph,
  Heading,
  LinkButton,
} from '@i22/td-longtail-vue-components';
import CdnImage from '~/components/cdn-image.vue';

export default {
  name: 'GoogleInfoTiles',
  components: {
    GridContainer,
    GridRow,
    GridColumn,
    Paragraph,
    CdnImage,
    Heading,
    LinkButton,
  },
  props: {
    tilesData: {
      type: Object,
      default: () => ({}),
    },
    showLink: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['go-to-section'],
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.google__info-tiles {
  &__row {
    gap: 2rem;
  }
  &__col {
    &-bg {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      z-index: -1;
      overflow: hidden;
      display: flex;
      justify-content: center;

      :deep(img) {
        aspect-ratio: 1;
        max-width: none;
        width: 100%;
        min-width: 100%;
        min-height: 100%;
        object-fit: cover;
      }
    }
    &__icon {
      width: auto;
      height: 60px;
    }
    &--p {
      padding: 2rem;
      aspect-ratio: 1 / 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    &__par {
      margin-bottom: 0;
    }
  }
  &__link {
    margin: 2rem auto;
  }
}
</style>
